// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_btnClose__rjueJ {
  background: transparent;
  border: none;
  padding: 0;
}
.style_btnClose__rjueJ svg {
  fill: #909399;
}

.style_modalDialog__vgT5P {
  width: 328px;
}
@media (max-width: 576px) {
  .style_modalDialog__vgT5P {
    width: auto;
  }
}
.style_modalDialog__vgT5P .style_modalHeader__0xqB4 {
  justify-content: space-between;
  border: none;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 {
  padding: 0;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_uplDlgBody__BOEZ0 {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_wrapperTabs__qWryp {
  padding: 0 16px;
  display: flex;
  gap: 8px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_wrapperTabs__qWryp .style_tab__TohcB {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: 1px solid rgba(95, 143, 223, 0.3);
  border-radius: 24px;
  height: 32px;
  padding: 4px 16px;
  width: 100%;
  font-size: 14px;
  line-height: 18px;
  font-weight: 300;
  transition: all 0.2s;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_wrapperTabs__qWryp .style_tab__TohcB.style_active__YfK\\+w {
  background-color: rgba(95, 143, 223, 0.3);
  font-weight: 500;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu {
  display: flex;
  flex-direction: column;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imageAddNew__g5vvR {
  margin: 0 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 41px;
  color: #5f8fdf;
  font-size: 16px;
  line-height: 28px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imageAddNew__g5vvR.style_error__EATBz {
  border: 1px dashed #ec205f;
  border-radius: 12px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_errorUpload__0Wdes {
  color: #ec205f;
  font-size: 12px;
  text-align: center;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_selectBox__tk9aY {
  padding: 0 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_selectBox__tk9aY span {
  font-size: 14px;
  line-height: 18px;
  color: #4a596a;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_actionBox__pedP8 {
  padding: 0 16px;
  display: flex;
  align-items: flex-end;
  gap: 8px;
  height: 65px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_actionBox__pedP8 .style_containerInput__KwZKZ {
  display: flex;
  width: 100%;
  gap: 8px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_actionBox__pedP8 .style_containerInput__KwZKZ div {
  width: 100%;
  padding: 0;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_actionBox__pedP8 .style_containerInput__KwZKZ .style_myPadding__Nrc1c div {
  padding: 0 10px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_actionBox__pedP8 .style_toggleBtn__4M9wC {
  display: flex;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_actionBox__pedP8 .style_toggleBtn__4M9wC .style_icoAction__rl\\+ti {
  cursor: pointer;
  display: flex;
  width: 39px;
  height: 39px;
  align-items: center;
  justify-content: center;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imagesListScroll__P79\\+X {
  padding: 0 16px;
  margin-top: 16px;
  display: inline-flexbox;
  align-items: left;
  width: 100%;
  height: 374px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imagesListScroll__P79\\+X .style_imagesListItems__8X1wr {
  width: 100%;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.3rem;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imagesListScroll__P79\\+X .style_imagesListItems__8X1wr .style_imgInsertBox__\\+Q0Zp {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  width: 144px;
  height: 120px;
  overflow: hidden;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imagesListScroll__P79\\+X .style_imagesListItems__8X1wr .style_imgInsertBox__\\+Q0Zp .style_imgInsert__4F\\+Lu {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: opacity 0.25s;
  cursor: pointer;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imagesListScroll__P79\\+X .style_imagesListItems__8X1wr .style_imgInsertBox__\\+Q0Zp .style_imgInsert__4F\\+Lu.style_focus__62O39 {
  border: 3px solid #5f8fdf;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imagesListScroll__P79\\+X .style_imagesListItems__8X1wr .style_imgInsertBox__\\+Q0Zp .style_imgInsert__4F\\+Lu.style_dontFocus__Uu2CC {
  opacity: 0.5;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_imagesListScroll__P79\\+X .style_imagesListItems__8X1wr .style_imgInsertBox__\\+Q0Zp .style_imgInsert__4F\\+Lu:hover {
  opacity: 1;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_notData__evml\\+ {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ec205f;
  background-color: rgba(236, 32, 95, 0.2);
  flex: 1 1;
  border-radius: 10px;
  padding: 10px 12px 8px;
  margin: 20px 16px 0 16px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX {
  margin-top: 16px;
  display: flex;
  height: 374px;
  flex-direction: column;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN {
  display: flex;
  flex-direction: column;
  padding: 0;
  list-style: none;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY {
  display: flex;
  cursor: pointer;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
  transition: all 0.2s;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY:hover {
  background-color: rgba(95, 143, 223, 0.3);
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY.style_focus__62O39 {
  background-color: rgba(95, 143, 223, 0.4);
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_headerTemplate__oYe9e {
  display: flex;
  align-items: center;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_headerTemplate__oYe9e .style_info__12kif {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 24px;
  border-right: 1px solid #e9e9eb;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_headerTemplate__oYe9e .style_info__12kif span:first-child {
  color: #4a596a;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_headerTemplate__oYe9e .style_info__12kif span:last-child {
  color: #4a596a;
  font-size: 12px;
  line-height: 16px;
  font-weight: 600;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_headerTemplate__oYe9e .style_action__9cVhZ {
  margin-left: 16px;
  display: flex;
  padding: 0 16px;
  gap: 16px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_headerTemplate__oYe9e .style_action__9cVhZ .style_ico__jZJZE {
  display: flex;
  align-items: center;
  justify-content: center;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_headerTemplate__oYe9e .style_action__9cVhZ .style_divider__hYxgD {
  border-left: 1px solid #e9e9eb;
  height: 24px;
}
.style_modalDialog__vgT5P .style_modalBody__Kb9t6 .style_contentTab__YElRu .style_messageListScroll__yC-TX .style_tmplMsgList__H32TN .style_templateMsg__ipVqY .style_messageTemplate__d9nhT {
  color: #4a596a;
  font-size: 16px;
  line-height: 28px;
  font-weight: 300;
  overflow-x: hidden;
  text-overflow: ellipsis;
}
.style_modalDialog__vgT5P .style_modalFooter__Z9601 {
  border: none;
}
.style_modalDialog__vgT5P .style_modalFooter__Z9601 .style_dlgBtns__XKQYW {
  width: 100%;
  display: flex;
  gap: 16px;
}
.style_modalDialog__vgT5P .style_modalFooter__Z9601 .style_dlgBtns__XKQYW button {
  width: 100%;
}

.style_addImgContainer__ZoVeI .style_btnAdd__-zlLy {
  cursor: pointer;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  position: relative;
  transition: color 0.15s;
}
.style_addImgContainer__ZoVeI .style_btnAdd__-zlLy:hover {
  color: #5f8fdf;
}
.style_addImgContainer__ZoVeI .style_btnAdd__-zlLy svg {
  position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/Dialog/AddImages/style.module.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAEA;EACE,uBAAA;EACA,YAAA;EACA,UAAA;AADF;AAGE;EACE,aCMa;ADPjB;;AAKA;EACE,YAAA;AAFF;AAIE;EAHF;IAII,WAAA;EADF;AACF;AAGE;EACE,8BAAA;EACA,YAAA;AADJ;AAIE;EACE,UAAA;AAFJ;AAII;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFN;AAKI;EACE,eAAA;EACA,aAAA;EACA,QAAA;AAHN;AAKM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;AAHR;AAKQ;EACE,yCAAA;EACA,gBAAA;AAHV;AAQI;EACE,aAAA;EACA,sBAAA;AANN;AAQM;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,cClEO;EDmEP,eAAA;EACA,iBAAA;AANR;AAQQ;EACE,0BAAA;EACA,mBAAA;AANV;AAUM;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AARR;AAWM;EACE,eAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AATR;AAWQ;EACE,eAAA;EACA,iBAAA;EACA,cCtFO;AD6EjB;AAaM;EACE,eAAA;EACA,aAAA;EACA,qBAAA;EACA,QAAA;EACA,YAAA;AAXR;AAaQ;EACE,aAAA;EACA,WAAA;EACA,QAAA;AAXV;AAaU;EACE,WAAA;EACA,UAAA;AAXZ;AAeY;EACE,eAAA;AAbd;AAkBQ;EACE,aAAA;AAhBV;AAkBU;EACE,eAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AAhBZ;AAqBM;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AAnBR;AAqBQ;EACE,WAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AAnBV;AAqBU;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AAnBZ;AAqBY;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAnBd;AAqBc;EACE,yBAAA;AAnBhB;AAsBc;EACE,YAAA;AApBhB;AAuBc;EACE,UAAA;AArBhB;AA4BM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,wCAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,wBAAA;AA1BR;AA6BM;EACE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AA3BR;AA6BQ;EACE,aAAA;EACA,sBAAA;EACA,UAAA;EACA,gBAAA;AA3BV;AA6BU;EACE,aAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,QAAA;EACA,oBAAA;AA3BZ;AA6BY;EACE,yCAAA;AA3Bd;AA8BY;EACE,yCAAA;AA5Bd;AA+BY;EACE,aAAA;EACA,mBAAA;AA7Bd;AA+Bc;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EACA,+BAAA;AA7BhB;AA+BgB;EACE,cCpOD;EDqOC,eAAA;EACA,iBAAA;EACA,gBAAA;AA7BlB;AAgCgB;EACE,cC3OD;ED4OC,eAAA;EACA,iBAAA;EACA,gBAAA;AA9BlB;AAkCc;EACE,iBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AAhChB;AAkCgB;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAhClB;AAmCgB;EACE,8BAAA;EACA,YAAA;AAjClB;AAsCY;EACE,cCtQG;EDuQH,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AApCd;AA4CE;EACE,YAAA;AA1CJ;AA4CI;EACE,WAAA;EACA,aAAA;EACA,SAAA;AA1CN;AA4CM;EACE,WAAA;AA1CR;;AAiDE;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cCxSa;EDySb,kBAAA;EAEA,uBAAA;AA/CJ;AAiDI;EACE,cCrTS;ADsQf;AAkDI;EACE,kBAAA;AAhDN","sourcesContent":["@import '../../../variables.scss';\n\n.btnClose {\n  background: transparent;\n  border: none;\n  padding: 0;\n\n  svg {\n    fill: $text-color-600;\n  }\n}\n\n.modalDialog {\n  width: 328px;\n\n  @media (max-width: 576px) {\n    width: auto;\n  }\n\n  .modalHeader {\n    justify-content: space-between;\n    border: none;\n  }\n\n  .modalBody {\n    padding: 0;\n\n    .uplDlgBody {\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      gap: 16px;\n    }\n\n    .wrapperTabs {\n      padding: 0 16px;\n      display: flex;\n      gap: 8px;\n\n      .tab {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: transparent;\n        border: 1px solid rgba($active-color, 0.3);\n        border-radius: 24px;\n        height: 32px;\n        padding: 4px 16px;\n        width: 100%;\n        font-size: 14px;\n        line-height: 18px;\n        font-weight: 300;\n        transition: all 0.2s;\n\n        &.active {\n          background-color: rgba($active-color, 0.3);\n          font-weight: 500;\n        }\n      }\n    }\n\n    .contentTab {\n      display: flex;\n      flex-direction: column;\n\n      .imageAddNew {\n        margin: 0 16px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 8px;\n        height: 41px;\n        color: $active-color;\n        font-size: 16px;\n        line-height: 28px;\n\n        &.error {\n          border: 1px dashed #ec205f;\n          border-radius: 12px;\n        }\n      }\n\n      .errorUpload {\n        color: #ec205f;\n        font-size: 12px;\n        text-align: center;\n      }\n\n      .selectBox {\n        padding: 0 16px;\n        display: flex;\n        flex-direction: column;\n        gap: 8px;\n\n        span {\n          font-size: 14px;\n          line-height: 18px;\n          color: $text-color-800;\n        }\n      }\n\n      .actionBox {\n        padding: 0 16px;\n        display: flex;\n        align-items: flex-end;\n        gap: 8px;\n        height: 65px;\n\n        .containerInput {\n          display: flex;\n          width: 100%;\n          gap: 8px;\n\n          div {\n            width: 100%;\n            padding: 0;\n          }\n\n          .myPadding {\n            div {\n              padding: 0 10px;\n            }\n          }\n        }\n\n        .toggleBtn {\n          display: flex;\n\n          .icoAction {\n            cursor: pointer;\n            display: flex;\n            width: 39px;\n            height: 39px;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n      }\n\n      .imagesListScroll {\n        padding: 0 16px;\n        margin-top: 16px;\n        display: inline-flexbox;\n        align-items: left;\n        width: 100%;\n        height: 374px;\n\n        .imagesListItems {\n          width: 100%;\n          padding: 0;\n          margin: 0;\n          display: grid;\n          grid-template-columns: 1fr 1fr;\n          gap: 0.3rem;\n\n          .imgInsertBox {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            margin: 0;\n            width: 144px;\n            height: 120px;\n            overflow: hidden;\n\n            .imgInsert {\n              width: 100%;\n              height: 100%;\n              object-fit: cover;\n              transition: opacity 0.25s;\n              cursor: pointer;\n\n              &.focus {\n                border: 3px solid $active-color;\n              }\n\n              &.dontFocus {\n                opacity: 0.5;\n              }\n\n              &:hover {\n                opacity: 1;\n              }\n            }\n          }\n        }\n      }\n\n      .notData {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: #ec205f;\n        background-color: rgb(236, 32, 95, 0.2);\n        flex: 1;\n        border-radius: 10px;\n        padding: 10px 12px 8px;\n        margin: 20px 16px 0 16px;\n      }\n\n      .messageListScroll {\n        margin-top: 16px;\n        display: flex;\n        height: 374px;\n        flex-direction: column;\n\n        .tmplMsgList {\n          display: flex;\n          flex-direction: column;\n          padding: 0;\n          list-style: none;\n\n          .templateMsg {\n            display: flex;\n            cursor: pointer;\n            flex-direction: column;\n            padding: 16px;\n            gap: 8px;\n            transition: all 0.2s;\n\n            &:hover {\n              background-color: rgba($active-color, 0.3);\n            }\n\n            &.focus {\n              background-color: rgba($active-color, 0.4);\n            }\n\n            .headerTemplate {\n              display: flex;\n              align-items: center;\n\n              .info {\n                display: flex;\n                flex-direction: column;\n                gap: 4px;\n                padding-right: 24px;\n                border-right: 1px solid $gray-box-border;\n\n                span:first-child {\n                  color: $text-color-800;\n                  font-size: 16px;\n                  line-height: 24px;\n                  font-weight: 700;\n                }\n\n                span:last-child {\n                  color: $text-color-800;\n                  font-size: 12px;\n                  line-height: 16px;\n                  font-weight: 600;\n                }\n              }\n\n              .action {\n                margin-left: 16px;\n                display: flex;\n                padding: 0 16px;\n                gap: 16px;\n\n                .ico {\n                  display: flex;\n                  align-items: center;\n                  justify-content: center;\n                }\n\n                .divider {\n                  border-left: 1px solid $gray-box-border;\n                  height: 24px;\n                }\n              }\n            }\n\n            .messageTemplate {\n              color: $text-color-800;\n              font-size: 16px;\n              line-height: 28px;\n              font-weight: 300;\n              overflow-x: hidden;\n              text-overflow: ellipsis;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .modalFooter {\n    border: none;\n\n    .dlgBtns {\n      width: 100%;\n      display: flex;\n      gap: 16px;\n\n      button {\n        width: 100%;\n      }\n    }\n  }\n}\n\n.addImgContainer {\n  .btnAdd {\n    cursor: pointer;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: $text-color-600;\n    position: relative;\n\n    transition: color 0.15s;\n\n    &:hover {\n      color: $active-color;\n    }\n\n    svg {\n      position: absolute;\n    }\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n\n$gray-background: #f5f5f7;\n$gray-border: #dce1e6;\n$gray-box-border: #e9e9eb;\n$gray-active: #eaedef;\n$active-color: #5f8fdf;\n$active-color-op: rgba(95, 143, 223, 0.4);\n// $active-color: #00ff95;\n$sender-message-color: #cce4ff;\n\n$text-color-800: #4a596a;\n$text-color-700: #626d7a;\n$text-color-600: #909399;\n\n$active-color-2: #ec205f;\n\n// $header-color: #add8e6;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btnClose": `style_btnClose__rjueJ`,
	"modalDialog": `style_modalDialog__vgT5P`,
	"modalHeader": `style_modalHeader__0xqB4`,
	"modalBody": `style_modalBody__Kb9t6`,
	"uplDlgBody": `style_uplDlgBody__BOEZ0`,
	"wrapperTabs": `style_wrapperTabs__qWryp`,
	"tab": `style_tab__TohcB`,
	"active": `style_active__YfK+w`,
	"contentTab": `style_contentTab__YElRu`,
	"imageAddNew": `style_imageAddNew__g5vvR`,
	"error": `style_error__EATBz`,
	"errorUpload": `style_errorUpload__0Wdes`,
	"selectBox": `style_selectBox__tk9aY`,
	"actionBox": `style_actionBox__pedP8`,
	"containerInput": `style_containerInput__KwZKZ`,
	"myPadding": `style_myPadding__Nrc1c`,
	"toggleBtn": `style_toggleBtn__4M9wC`,
	"icoAction": `style_icoAction__rl+ti`,
	"imagesListScroll": `style_imagesListScroll__P79+X`,
	"imagesListItems": `style_imagesListItems__8X1wr`,
	"imgInsertBox": `style_imgInsertBox__+Q0Zp`,
	"imgInsert": `style_imgInsert__4F+Lu`,
	"focus": `style_focus__62O39`,
	"dontFocus": `style_dontFocus__Uu2CC`,
	"notData": `style_notData__evml+`,
	"messageListScroll": `style_messageListScroll__yC-TX`,
	"tmplMsgList": `style_tmplMsgList__H32TN`,
	"templateMsg": `style_templateMsg__ipVqY`,
	"headerTemplate": `style_headerTemplate__oYe9e`,
	"info": `style_info__12kif`,
	"action": `style_action__9cVhZ`,
	"ico": `style_ico__jZJZE`,
	"divider": `style_divider__hYxgD`,
	"messageTemplate": `style_messageTemplate__d9nhT`,
	"modalFooter": `style_modalFooter__Z9601`,
	"dlgBtns": `style_dlgBtns__XKQYW`,
	"addImgContainer": `style_addImgContainer__ZoVeI`,
	"btnAdd": `style_btnAdd__-zlLy`
};
export default ___CSS_LOADER_EXPORT___;
